import { render, staticRenderFns } from "./OldAddQualificationsData.vue?vue&type=template&id=7f2549b4"
import script from "./OldAddQualificationsData.vue?vue&type=script&lang=js"
export * from "./OldAddQualificationsData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports